import { Box, Flex, Text } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

interface PageProps extends PropsWithChildren {
    heading?: string;
}

export const Page = ({ children, heading }: PageProps) => {
    return (
        <Flex flexDirection="column" h="100%" gap="12px" w="100%" maxW={{ lg: '701px', '2xl': '920px' }}>
            {heading && (
                <Text fontSize="lg" fontWeight={500}>
                    {heading}
                </Text>
            )}
            <Flex flexDirection="column" h="100%" gap="32px" w="100%">
                {children}
                <Flex flexDirection="column" h="100%" w="100%">
                    <Box h="16px" />
                </Flex>
            </Flex>
        </Flex>
    );
};
